module.exports = __webpack_public_path__ + "odinstatic/v13.0.1/media/sidebar-shield-active.c2b48cd4.svg";